<template>
  <div class="index-module_articleWrap_2Zphx">
      <div  class="zhemo">文华视频课堂 - 用wh5来做股票量化研究</div>
        <p class="index-module_textWrap_3ygOc">通晓经济、金融、数学、计算机、心理、市场……才能做量化？投研已经很辛苦，改个策略动辄需要重写几百行代码？写个算法需要捧起厚重的统计学教材？还得投入重金购买数据库和服务器？
        </p>
        <p class="index-module_textWrap_3ygOc">No，这些都不用！wh5率先推出了涵盖全流程、界面式操作的多因子策略量化工具，量化投研不再需要复杂的编程、高深的数理统计，不再用承担服务器和数据库的成本，轻松实现“有了wh5,自己做量化基金经理”的愿望，一切就是这么简单！
        </p>
        <p class="index-module_textWrap_3ygOc">本期课程我们将使用wh5涵盖全流程、界面式操作的多因子策略量化工具复现经典的沪深300指数增强策略，并讲述如何使用文华原创因子提高策略收益，利用wh5多样化组合优化、多维度分析报告，构建最优策略组合。</p>
        <p class="index-module_textWrap_3ygOc">
            课程：有了wh5，无需编程，轻松实现股票量化
        </p>
         <div class="info table2">
            <table cellpadding="7" cellspacing="0" style="width: 730px;background: #f7f9fc;text-indent:0">
                <tr class="center">
                    <th valign="top" colspan="2">内容</th>
                    <th valign="top" width="14%">讲师</th>
                </tr>
                <tr>
                    <td rowspan="2"  style="padding:0 5px;text-align:center;text-indent:0">文华因子库</td>
                    <td>	因子库详解 - 包含基础因子、精选因子、原创因子和行业因子4个大类，共计1100多个因子。</td>
                    <td rowspan="6"  style="padding:0 5px;text-align:center;text-indent:0">孙健</td>
                </tr>
                <tr>
                    <td>文华原创因子 - 实现价值投资和量化研究的融合。</td>
                </tr>
                <tr>
                    <td rowspan="3"  style="padding:0 5px;text-align:center;text-indent:0">多因子选股策略量化</td>
                    <td>多因子选股策略量化工具 - 无需编程，11个步骤，复现沪深300指数增强策略。</td>
                </tr>
                <tr>
                    <td>因子时效性参考 - 把握大类因子有效周期，实现因子优化选择。</td>
                </tr>
                <tr>
                    <td>择时优化 - 通过编写择时策略模型，优化建仓时机，降低建仓成本。</td>
                </tr>
                <tr>
                    <td  style="padding:0 5px;text-align:center;text-indent:0">行业轮动策略量化</td>
                    <td>行业轮动策略量化工具 - 把握行业涨跌节奏、洞悉结构化行情，赚取行业超额收益。</td>
                </tr>
            </table>
        </div>
        <div  class="index-module_textWrap_3ygOc">
                讲师介绍：
        </div>
        <div>【孙健】&nbsp;文华产品经理</div>
            <div  class="index-module_textWrap_3ygOc">
                十年来专注于套利及量化交易研究工作，每年多次在全国范围内举办和参与套利和量化方面的大型授课活动，现主要负责服务机构客户，为专业的投资者提供技术支持，解决实际使用中的问题。
        </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>
.info,
.SignUp {
    color: #646464;
    line-height: 180%;
    padding: 0 0 3px 2em;
    font-size: 14px;
}
.info table{
    border: 1px solid #d1d7d7;
    border-collapse: collapse;
}

.info_2 {
    color: #646464;
    line-height: 180%;
    padding-bottom: 3px;
}

.info table {
    width: 688px;
}

.info th {
            padding: 5px 0;

    height: 24px;
    line-height: 24px;
    background: #a4bce2;
    color: #ffffff;
    border: 1px solid #d1d7d7;
    font-size: 14px;
    font-weight: normal;
    text-align: center;
}

.info td {
    padding: 0;
     padding: 5px 8px;

    border: 1px solid #d1d7d7;
    vertical-align: middle;
    padding-left: 8px;
}

.info td.time {
    color: #002c6f;
}

.td_w,.td_b{
    line-height: 29px;
    padding: 0 0 0 22px;
    font-size: 14px;
    color: #646567;
}

.td_b{
    background: #eef0fd;
}
</style>